module.exports = __webpack_public_path__ + "img/MK_Screen_3.8556eb84.jpg";